import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';

import getStyles from './styles';

const RefreshIndicator = ({
    left = 0,
    size = 40,
    status = 'hide',
    style,
    top = 0,
    thickness = 5,
}) => {
    const styles = Object.assign(getStyles(size, top, left), style);

    return (
        status !== 'hide' && (
            <Paper style={styles} data-testid="refresh-indicator">
                <CircularProgress size={size * 0.6} thickness={thickness} data-testid="circular-progress" />
            </Paper>
        )
    );
};

RefreshIndicator.propTypes = {
    left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    size: PropTypes.number,
    status: PropTypes.oneOf(['loading', 'hide']),
    style: PropTypes.object,
    top: PropTypes.number,
    thickness: PropTypes.number,
};

RefreshIndicator.defaultProps = {
    size: 40,
    status: 'hide',
    thickness: 5,
    top: 0,
    left: 0,
};

export default RefreshIndicator;
